import './ComoFunciona.css';

const STEPS = [
  {
    num: '01',
    icon: '🛍️',
    title: 'Você compra',
    body: 'Escolhe sua peça favorita e finaliza o pedido. Simples, seguro e com entrega para todo o Brasil.',
  },
  {
    num: '02',
    icon: '🐾',
    title: 'A ONG recebe',
    body: 'O valor vai diretamente para os projetos da ONG Amanimal, sem intermediários.',
  },
  {
    num: '03',
    icon: '🏡',
    title: 'Animais são cuidados',
    body: 'Ração, veterinário, abrigo e muito amor para quem aguarda uma família.',
  },
];

export default function ComoFunciona() {
  return (
    <section id="como" className="como">
      <div className="como__inner">
        <div className="como__header">
          <span className="como__tag">Como Funciona</span>
          <h2 className="como__title">Simples assim</h2>
          <p className="como__subtitle">
            Comprar na Amanimal é apoiar de verdade. Veja como sua compra
            percorre o caminho até chegar a quem mais precisa.
          </p>
        </div>

        <div className="como__steps">
          {STEPS.map((s, i) => (
            <div key={s.num} className="como__step-wrap">
              <div className="como__card">
                <div className="como__card-top">
                  <span className="como__num">{s.num}</span>
                  <span className="como__icon">{s.icon}</span>
                </div>
                <h3 className="como__step-title">{s.title}</h3>
                <p className="como__step-body">{s.body}</p>
              </div>

              {i < STEPS.length - 1 && (
                <div className="como__arrow" aria-hidden="true">
                  <svg viewBox="0 0 48 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 12 H40 M32 4 L44 12 L32 20" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
